const cleanText = (value) => {
  if (value == null) return "";
  const trimmed = String(value).trim();
  return trimmed || "";
};

export const formatAddressLines = (address) => {
  if (!address) return [];
  const line1 = cleanText(address.line1 || address.address_line1);
  const line2 = cleanText(address.line2 || address.address_line2);
  const city = cleanText(address.city);
  const province = cleanText(address.province || address.province_state);
  const postalCode = cleanText(address.postal_code);
  const country = cleanText(address.country);
  const lines = [];
  if (line1) lines.push(line1);
  if (line2) lines.push(line2);
  let cityLine = [city, province].filter(Boolean).join(", ");
  if (postalCode) {
    cityLine = cityLine ? `${cityLine} ${postalCode}` : postalCode;
  }
  if (cityLine) lines.push(cityLine);
  if (country) lines.push(country);
  return lines;
};

export const formatAddressText = (address) => {
  const lines = formatAddressLines(address);
  return lines.length ? lines.join("\n") : "";
};

export const coerceAddressText = (address) => {
  if (!address) return "";
  if (typeof address === "string") return address.trim();
  return formatAddressText(address);
};

const normalizeAddressQuery = (addressText) => {
  const cleaned = cleanText(addressText);
  if (!cleaned) return "";
  return cleaned.replace(/\s*\n\s*/g, ", ");
};

export const buildMapLinkUrl = (addressText) => {
  const query = normalizeAddressQuery(addressText);
  if (!query) return "";
  return `https://www.google.com/maps?q=${encodeURIComponent(query)}`;
};

export const buildMapEmbedUrl = (addressText) => {
  const link = buildMapLinkUrl(addressText);
  if (!link) return "";
  return `${link}&output=embed`;
};
